// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"278":"d84c041b","357":"3d9f1150","360":"cf77af4a","407":"3239045a","757":"40c5e597","904":"6011fe04"}[chunkId] + ".chunk.js";
};